import GlobalEvent from "./Event";
import Store from "../store/";
import Moment from "moment";
import VueRouter from "@/routes/index";
import i18n from "@/i18n";

let lastUpdate = Moment();
// 세션 유지 시간
let sessionDuration = Moment.duration(24, "hours");
// 세션 만료 알림 시간(n분 전)
let sessionExpireNotiTime = Moment.duration(-3, "minutes");

class Session {
  constructor() {
    lastUpdate = Moment();
    this.timer = setInterval(this.checkTime.bind(this), 1000);
  }

  checkTime() {
    if (Store.getters.isLogin) {
      const now = Moment();
      if (now > this.expireTime && Store.getters.isLogin) {
        // 세션 만료됨. 로그아웃
        this.forceLogout();
        // VueRouter.push({ name: "Login" });
        // GlobalEvent.$emit("popup", {
        //   title: i18n.t("notice.title.logoutInformation"),
        //   hasHTML: true,
        //   content: i18n.t("notice.content.popupAutomaticallyLoggedOut"),
        //   buttons: [
        //     {
        //       type: "CANCEL",
        //       text: i18n.t("notice.content.doLater"),
        //       onClick: () => VueRouter.push({ name: "Login" }),
        //     },
        //     {
        //       type: "OK",
        //       text: i18n.t("notice.content.login"),
        //       onClick: () => VueRouter.push({ name: "Login" }),
        //     },
        //   ],
        //   closehidden: true,
        // });
        // } else if (now > this.expireNotiTime && Store.getters.isLogin) {
        //   GlobalEvent.$emit("popup", {
        //     title: "로그아웃 안내",
        //     hasHTML: true,
        //     content: `${(i18n.t("notice.content.extendLoginTimeContinue"),
        //     [
        //       Moment(this.remainSessionTime).format("mm"),
        //       Moment(this.remainSessionTime).format("ss"),
        //     ])}`,
        //     buttons: [
        //       {
        //         type: "CANCEL",
        //         text: "로그아웃",
        //         onclick: () => VueRouter.push({ name: "Login" }),
        //       },
        //       {
        //         type: "OK",
        //         text: "로그인 연장",
        //         onClick: this.extend.bind(this),
        //       },
        //     ],
        //   });
        // }
      }
    } else {
      this.extend();
    }
  }

  extend() {
    lastUpdate = Moment();
  }

  get expireTime() {
    return Moment(lastUpdate).add(sessionDuration);
  }

  get expireNotiTime() {
    return Moment(this.expireTime).add(sessionExpireNotiTime);
  }

  get remainSessionTime() {
    return Moment(this.expireTime).diff();
  }

  forceLogout() {
    return Store.dispatch("logOut");
  }
}

const session = new Session();
// window.sess = session;
export default session;
